import { Box, IconButton, styled } from "@mui/material";

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
    borderRadius: "8px",
    border: "2px solid white",
    boxShadow: "0px 0px 5px rgba(0,0,0,0.2)",
    transition: "border 200ms ease-in-out",
    "&:hover": {
        border: `2px solid ${theme.palette.primary.main}`,
    },
}));

export const LanguageSwitch = styled(Box)(({ theme }) => ({
    display: 'flex',
    border: `4px solid`,
    borderColor: `${theme.palette.primary.main}`, 
    borderRadius: "20px", 
    overflow: 'hidden',
    marginLeft: 'auto',
    width: 'fit-content',
    backgroundClip: "padding-box", 
}));

export const LanguageOpt = styled(Box)({
    cursor: "pointer",
    padding: "8px 16px",
    transition: "all 0.3s ease-in-out",
    fontWeight: 700,
    fontSize: "0.8rem",
});